<template>
  <section class="instruction">
    <h3 class="title-small">Instructies</h3>
    <p>{{ instruction }}</p>
  </section>
</template>

<script>
export default {
  props: ['instruction']
}
</script>
<style lang="scss" scoped>
.instruction p {
  white-space: pre-wrap;
}
</style>
